import { createSelector } from "reselect";

export const getAppSelector = createSelector(
    state => state.app,
    state => state
);

export const getAuthPolicySelector = createSelector(
    state => state.app.authPolicyCodes,
    state => state
);

export const sidParamsSelector = createSelector(
    state => state.app.sidParams,
    state => state
);

export const isLoadingAppSelector = createSelector(
    state => state.app.isLoading,
    state => state
);

export const userSelector = createSelector(
    state => state.app.user,
    state => state
);

export const shortUrlSelector = createSelector(
    state => state.app.shortUrl,
    state => state
);